import React from 'react';
import { Link } from 'react-router-dom';
import { latestRelease } from '../../data/products';
import './FeaturedMusic.css';

const FeaturedMusic: React.FC = () => {
  const release = latestRelease;

  return (
    <section className="featured-music" aria-label="Featured music">
      <div className="featured-music__inner container">
        <div className="featured-music__header">
          <p className="featured-music__eyebrow">{release.eyebrow}</p>
        </div>

        <div className="featured-music__layout">
          {/* Cover + release info */}
          <div className="featured-music__release">
            <div className="featured-music__cover-wrap">
              <img
                src={release.coverImage}
                alt={`${release.title} album artwork`}
                className="featured-music__cover"
                width={220}
                height={220}
                loading="lazy"
              />
            </div>
            <div className="featured-music__release-info">
              <h3 className="featured-music__release-title">{release.title}</h3>
              <p className="featured-music__release-type">{release.releaseType}</p>
              <p className="featured-music__release-note">{release.note}</p>
              <div className="featured-music__platforms">
                {release.spotify && (
                  <a href={release.spotify} target="_blank" rel="noopener noreferrer" className="featured-music__platform-link" aria-label="Listen on Spotify">
                    <SpotifyIcon /> Spotify
                  </a>
                )}
                <a href="https://music.apple.com" target="_blank" rel="noopener noreferrer" className="featured-music__platform-link" aria-label="Listen on Apple Music">
                  <AppleIcon /> Apple Music
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="featured-music__platform-link" aria-label="Watch on YouTube">
                  <YouTubeIcon /> YouTube
                </a>
              </div>
            </div>
          </div>

          {/* Track list */}
          {release.tracks.length > 0 && (
            <div className="featured-music__tracklist">
              <ol className="featured-music__tracks">
                {release.tracks.map((track) => (
                  <li key={track.number} className="featured-music__track">
                    <span className="featured-music__track-num">{track.number}</span>
                    <span className="featured-music__track-title">{track.title}</span>
                    <span className="featured-music__track-duration">{track.duration}</span>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>

        <div className="featured-music__footer">
          <Link to="/music" className="featured-music__view-all">
            View All Music
          </Link>
        </div>
      </div>
    </section>
  );
};

/* Icons */
const SpotifyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 11.5c2.5-1 5.5-1 8 0M7 14.5c3-1.2 7-1.2 10 0M9 17.5c2-0.8 5-0.8 7 0" />
  </svg>
);

const AppleIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M12 20.94c1.5.49 4.5 1.56 4.5 1.56s1-2.5 1-5 -1-4.5-1-4.5c-1.5 1.5-4.5 2-7.5 2 -3 0-6-.5-7.5-2C1.5 13 .5 13.5.5 16.5s1 5 1 5 3-1.07 4.5-1.56M18.5 8c0 3-2.5 4.5-6.5 4.5S5.5 11 5.5 8 8.5 1.5 12 1.5 18.5 5 18.5 8z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.44a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" />
  </svg>
);

export default FeaturedMusic;
